import React from 'react';
import { useNavigate } from 'react-router-dom';
import Image from '../../../components/AppImage';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const CaseStudyCard = ({ caseStudy }) => {
  const navigate = useNavigate();

  const handleViewDetails = () => {
    console.log('View case study:', caseStudy?.id);
  };

  return (
    <div className="bg-card rounded-xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300 group">
      <div className="relative h-48 md:h-56 lg:h-64 overflow-hidden">
        <Image
          src={caseStudy?.image}
          alt={caseStudy?.imageAlt}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        <div className="absolute top-4 left-4 flex flex-wrap gap-2">
          <span className="px-3 py-1 bg-primary text-primary-foreground text-xs font-semibold rounded-full">
            {caseStudy?.industry}
          </span>
          <span className="px-3 py-1 bg-accent text-accent-foreground text-xs font-semibold rounded-full">
            {caseStudy?.service}
          </span>
        </div>
      </div>
      <div className="p-4 md:p-5 lg:p-6">
        <h3 className="text-lg md:text-xl lg:text-2xl font-bold text-foreground mb-2 md:mb-3 line-clamp-2 font-heading">
          {caseStudy?.title}
        </h3>
        
        <p className="text-sm md:text-base text-text-secondary mb-4 md:mb-5 line-clamp-3">
          {caseStudy?.description}
        </p>

        <div className="grid grid-cols-3 gap-3 md:gap-4 mb-4 md:mb-5 pb-4 md:pb-5 border-b border-border">
          {caseStudy?.metrics?.map((metric, index) => (
            <div key={index} className="text-center">
              <div className="text-xl md:text-2xl lg:text-3xl font-bold text-primary mb-1">
                {metric?.value}
              </div>
              <div className="text-xs md:text-sm text-text-secondary">
                {metric?.label}
              </div>
            </div>
          ))}
        </div>

        <div className="flex items-center justify-between mb-4 md:mb-5">
          <div className="flex items-center gap-2 md:gap-3">
            <Image
              src={caseStudy?.clientLogo}
              alt={caseStudy?.clientLogoAlt}
              className="w-8 h-8 md:w-10 md:h-10 rounded-lg object-contain bg-muted p-1"
            />
            <div>
              <div className="text-xs md:text-sm font-semibold text-foreground">
                {caseStudy?.clientName}
              </div>
              <div className="text-xs text-text-secondary">
                {caseStudy?.duration}
              </div>
            </div>
          </div>
          <div className="flex items-center gap-1 text-warning">
            {[...Array(5)]?.map((_, i) => (
              <Icon key={i} name="Star" size={14} className="fill-current" />
            ))}
          </div>
        </div>

        <Button
          variant="outline"
          fullWidth
          onClick={handleViewDetails}
          iconName="ArrowRight"
          iconPosition="right"
        >
          View Full Case Study
        </Button>
      </div>
    </div>
  );
};

export default CaseStudyCard;